module.exports = __webpack_public_path__ + "static/img/Krux-Default.c32be1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Krux-Default.png
// module id = 1594
// module chunks = 0